// import { Joi } from 'app-webtech-core/schemas';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { MUTE } from './types';

const playerMuteAction = actionCreator(MUTE);

export const playerMuteThunkAction = (payload) => (dispatch) => dispatch(playerMuteAction(payload));
